const shape = {
  borderRadius: 2
};

export default shape;
